import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RequestDirectDealModal } from '../../components/requestModal/RequestDirectDealModal.tsx';
import { PublisherLogo } from '../../DirectDealsList/parts/PublisherLogo.tsx';
import { useDirectDealsContext } from '../../utils/context/DirectDealsContext.tsx';
import { useDirectDealsPublisherDetails } from '../../utils/context/DirectDealsPublisherDetailsContext.tsx';
import { useRequestDirectDealModalContext } from '../../utils/context/RequestDirectDealModalContext.tsx';

export const DirectDealsDetailsHeader = () => {
  const { t } = useTranslation();
  const publisherDetails = useDirectDealsPublisherDetails();
  const { useDirectDealsContact } = useDirectDealsContext();
  const { canContactAgain } = useDirectDealsContact(publisherDetails?.id || '');
  const { openModal } = useRequestDirectDealModalContext();
  const [isButtonEnabled, setIsButtonEnabled] = useState<boolean>(canContactAgain);

  if (!publisherDetails) {
    return null;
  }

  const handleContactButton = () => {
    openModal({
      publisherId: publisherDetails.id,
      publisherName: publisherDetails.name,
      callback: () => setIsButtonEnabled(false),
    });
  };

  return (
    <>
      <Grid
        container
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          padding: 4,
          width: 1,
          bgcolor: 'background.boxLight',
        }}
      >
        <Grid
          size={3}
          sx={{
            paddingRight: 4,
          }}
        >
          <Box
            sx={{
              border: 1,
              paddingTop: 1,
              paddingBottom: 1,
              paddingLeft: 2,
              paddingRight: 2,
              borderColor: 'divider',
              bgcolor: 'white',
              aspectRatio: '16 / 9',
            }}
          >
            <PublisherLogo name={publisherDetails.logo} />
          </Box>
        </Grid>

        <Grid size={6}>
          <Box
            sx={{
              marginBottom: 2,
            }}
          >
            <Typography data-test="publisher-name" variant="h1">
              {publisherDetails.name}
            </Typography>
            <Typography
              data-test="publisher-headline"
              variant="body1Bold"
              sx={{
                marginTop: 1,
                color: 'text.secondary',
              }}
            >
              {publisherDetails.headline}
            </Typography>
            <Typography
              data-test="publisher-description"
              variant="body1"
              sx={{
                marginTop: 1,
                color: 'text.secondary',
              }}
            >
              {publisherDetails.description}
            </Typography>
          </Box>

          <Tooltip
            title={isButtonEnabled ? '' : t("You've already requested contact with this publisher!")}
            placement="top"
          >
            <Box sx={{ width: 'max-content' }}>
              <Button
                type="submit"
                color="primary"
                disabled={!isButtonEnabled}
                data-test="connect-with-publisher-button"
                onClick={handleContactButton}
              >
                {t('Connect with publisher')}
              </Button>
            </Box>
          </Tooltip>
        </Grid>

        <Divider />
      </Grid>

      <RequestDirectDealModal />
    </>
  );
};
